export class ParsedToken {
  constructor(
    public username: string,
    public issuedAt: Date,
    public expiredAt: Date
  ) { }

  get isExpired(): boolean {
    return this.expiredAt.getTime() <= Date.now();
  }

  expiresInMs(now = Date.now()): number {
    return this.expiredAt.getTime() - now;
  }
}

export class SessionInfo {
  constructor(
    public username: string,
    public token: string,
    public roles: string[],
    public privileges: string[],
    public issuedAt?: Date,
    public expiredAt?: Date
  ) { }

  get isExpired(): boolean {
    return this.expiredAt ? this.expiredAt.getTime() <= Date.now() : false;
  }

  expiresInMs(now = Date.now()): number {
    return this.expiredAt ? this.expiredAt.getTime() - now : Number.POSITIVE_INFINITY;
  }
}

export class Session {
  constructor(
    public authenticated: boolean,
    public info?: SessionInfo
  ) { }

  hasRole(role: string): boolean {
    return this.info?.roles.includes(role) ?? false;
  }

  hasPrivilege(privilege: string): boolean {
    return this.info?.privileges.includes(privilege) ?? false;
  }

  get isExpired(): boolean {
    return this.authenticated ? (this.info?.isExpired ?? true) : false;
  }
}